import type { MembershipPayload } from '@/store/types/MembershipPayload'
import * as api from '@/backend/api'
import { errorMessages, isErrorResponse, parseError, type ParsedError } from '@/backend/error'
import type { AxiosResponse } from 'axios'
import { getTeamIdOrSlug } from '@/backend/getTeamIdOrSlug'

type Params = { teamId: number } | { teamSlug: string }

/**
 * Get the list of team members for the specified team
 */
export const loadTeamMemberships = async (params: Params): Promise<AxiosResponse | ParsedError> => {
  const path = `teams/${getTeamIdOrSlug(params)}/memberships`

  try {
    const response = await api.get<MembershipPayload[]>(path)
    return response
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return parseError(error, errorMessages.TEAM_MEMBERS_LOAD)
  }
}
